{
  "table": {
    "empty": "Таблица пустая",
    "notVisibleColumns": "Вы скрыли все колонки у таблицы"
  }
}
